export interface MilestoneCardData {
	key: string;
	value: number | string;
	currencyCode?: string;
}

export interface CardMetadata {
	header: string;
	icon: string;
	iconClass: string;
	type: "currency" | "headcount" | "percentage" | "custom";
}

export const CARD_METADATA: Record<string, CardMetadata> = {
	totalCount: {
		header: "Headcount",
		icon: "3user",
		iconClass: "icon-headcount",
		type: "headcount"
	},
	totalAmount: {
		header: "Total Payments",
		icon: "bank-figma2",
		iconClass: "icon-payments",
		type: "currency"
	},
	totalPayroll: {
		header: "Total Payroll",
		icon: "document-text",
		iconClass: "icon-payroll",
		type: "currency"
	},
	totalDeductionAmount: {
		header: "Total Deductions",
		icon: "receipt-subtract",
		iconClass: "icon-deductions",
		type: "currency"
	}
};
